import actions from './moduleEmployeeActions.js'
import getters from './moduleEmployeeGetters.js'
import mutations from './moduleEmployeeMutations.js'
import state from './moduleEmployeeState.js'

export default {
  isRegistered: false,
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}
